import React from 'react';
import { Callout } from '../deck/Callout';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { FraudMockup } from '../mockups/FraudMockup';
export function FreeOptionSlide() {
  return <StepSlide step={6} title="Add extras: choose the free option" visual={<FraudMockup data-id="element-220" data-mp="1kdx8mim66g9" />} visualLabel="Fraud protection page with Continue with Standard marked Not this and the Lite link marked Yes, click this" data-id="element-219" data-mp="3tpzvxtpy5dbs">
      <StepList items={[<>You'll see "Protect your business from fraud" with paid plans.</>, <>
            <strong data-id="element-222" data-mp="3a0fqmt92in8i">Don't</strong> click the big purple <strong data-id="element-223" data-mp="3a3li2f56617e">"Continue with Standard"</strong>{' '}
            button. That one costs money.
          </>, <>
            Click the small underlined words below it:{' '}
            <strong data-id="element-224" data-mp="pb04wcophopq">"Use baseline protection with Lite (included)"</strong>. It's free.
          </>]} data-id="element-221" data-mp="35zvqrhx415io" />
      <Callout data-id="element-225" data-mp="uc5ysdu3ri0u">
        If Stripe asks about other extras next (like tax calculation or climate contributions),
        skip them. You don't need them.
      </Callout>
    </StepSlide>;
}